import * as React from 'react';
import * as cx from 'classnames';

import { withIntl, IntlProps } from 'ha/i18n';
import MediaQuery from 'ha/helpers/MediaQuery';
import { H1 } from 'ha/ui/Headers';
import Track from 'ha/components/track/SmartTrack';
import Link from 'ha/ui/Link';

interface Props {
  isAuthenticated: boolean;
  showModal: (name: string, nextUrl: string) => void;
}

export const AboveTheFold: React.SFC<Props & IntlProps> = ({
  intl: { T, urlResolver },
  showModal,
  isAuthenticated,
}) => (
  <MediaQuery>
    {({ sm, md, lg }) => (
      <div className="landing-first-screen">
        <div className="row m-x-0">
          <div className="col-xs-24 col-md-10 col-xl-12 relative">
            <div
              className={cx(
                'landing-first-screen__image supply-landing-first-screen__image block-cover z-index-0',
              )}
            />
            {!md && (
              <div className="block-cover back-dark opacity-0_3 z-index-1" />
            )}
            {!md && (
              <H1
                className={cx(
                  'm-t-8 m-b-2 text-center color-white color-black-shadow relative z-index-2',
                  sm ? 'font-size-xl' : 'font-size-xxlg',
                )}
              >
                {T("The world's leading accommodation market")}
              </H1>
            )}
          </div>
          <div className="col-xs-24 col-md-14 col-xl-12 back-dark color-white">
            <div
              className={cx(
                md
                  ? 'm-l-2 m-r-1 landing-first-screen__content'
                  : 'text-center',
              )}
            >
              {md && (
                <H1
                  className={cx(
                    'break-word m-t-8',
                    lg ? 'landing-first-screen__title' : 'font-size-xl',
                  )}
                >
                  {T("The world's leading accommodation market")}
                </H1>
              )}
              <div className={cx('m-y-1_5', { 'font-size-xlg': md })}>
                {T(
                  'Get access to verified tenants with an above-average budget',
                )}
              </div>
              <div>
                <Track name="Clicked CTA List your place" type="link">
                  <Link
                    to={urlResolver.getListYourPlaceUrl()}
                    className="btn btn-brand text-bold btn-lg box-shadow-md m-b-1_5"
                    skipLangFormat
                    onClick={
                      isAuthenticated
                        ? undefined
                        : e => {
                            e.preventDefault();
                            showModal(
                              'register',
                              urlResolver.getListYourPlaceUrl(),
                            );
                          }
                    }
                  >
                    {T('List your first property for free')}
                  </Link>
                </Track>
              </div>
              <div className="m-b-2 inline-block relative">
                {T('Or scroll down to learn more')}
                <div className="absolute left-50 m-t-0_5 back-white supply-landing-first-screen__vertical-line" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  </MediaQuery>
);

export default withIntl(AboveTheFold);
